module.exports = __webpack_public_path__ + "img/12.796e80fa.png";